<template>
  <div id="userwxpart">
      <div class="tos">
         <el-form :inline="true" :model="userDto" label-width="100px"  class="demo-form-inline">
            <el-form-item label="手机号：">
               <el-input v-model="userDto.phone"></el-input>
            </el-form-item>
            <el-form-item label="用户类型：">
            <el-select v-model="userDto.userType" clearable placeholder="请选择用户类型">
               <el-option
                  v-for="item in yhlxoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
               </el-option>
            </el-select>
         </el-form-item>
            <el-form-item>
               <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
            </el-form-item>
         </el-form>
         <el-button class="right-item"  type="primary" @click=newoks()>注册</el-button>
      </div>
      <div class="tableform">
        <el-table
            :data="tableData"
            border
            stripe
            :cell-style="{'text-align':'center'}"
            :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
            style="width: 100%">
            <el-table-column
               prop="userName"
               label="用户名"
               >
               <template slot-scope="{row:{ userName }}">
               {{ userName|| "—" }}
               </template>
            </el-table-column>
            <el-table-column
               prop="phone"
               label="手机号"
               >
               <template slot-scope="{row:{ phone }}">
               {{ phone|| "—" }}
               </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="380">
               <template slot-scope="scope">
                     <el-button @click="handleClick(scope.row)" type="success"  size="small">编辑</el-button>
                     <el-button type="warning" size="small" @click=czsydemm(scope.row) >重置</el-button>
                     <el-button type="primary" size="small" @click="intos(scope.row)" >绑定</el-button>
                     <el-button type="danger" size="small" @click="dels(scope.row)" >删除</el-button>
               </template>
            </el-table-column>
         </el-table>
         <div class="btnbox">
            <el-pagination
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               :current-page="userDto.pageNum"
               :page-sizes="[10, 15, 20]"
               :page-size="userDto.pageSize"
               layout="total, sizes, prev, pager, next, jumper"
               :total="this.totals">
            </el-pagination>
         </div>
         </div>
         <!-- 注册用户弹框 -->
         <el-dialog title="注册" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="registerUserDto" :model="registerUserDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="用户名：" prop="userName">
                    <el-input v-model="registerUserDto.userName" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="pwd">
                    <!-- <el-input type="password" v-model="registerUserDto.userPwd" placeholder="请输入..."></el-input> -->
                    <el-input  v-model="registerUserDto.pwd" show-password placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="registerUserDto.phone" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="用户类型：">
                  <el-select v-model="registerUserDto.userType"  placeholder="请选择用户类型">
                     <el-option
                        v-for="item in yhlxoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
                </el-form-item>
               
                <el-form-item label="邮箱：">
                    <el-input v-model="registerUserDto.email" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="头像：">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                     :limit="1"
                     :http-request="handleRequest"
                     :on-preview="handlePreview"
                     :on-remove="handleRemove"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                     :file-list="fileList"
                  >
                  <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('registerUserDto',registerUserDto)">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改弹框 -->
        <el-dialog title="注册" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="registerUserDto" :model="registerUserDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="用户名：" prop="userName">
                    <el-input v-model="registerUserDto.userName" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="registerUserDto.phone" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="用户类型：">
                  <el-select v-model="registerUserDto.userType"  placeholder="请选择用户类型">
                     <el-option
                        v-for="item in yhlxoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮箱：">
                    <el-input v-model="registerUserDto.email" placeholder="请输入..."></el-input>
                </el-form-item>
                <el-form-item label="头像：">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                      :limit="1"
                     :http-request="handleRequest"
                     :on-preview="handlePreview"
                     :on-remove="handleRemove"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                      :file-list="fileList"
                  >
                  <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="xiugoks('registerUserDto',registerUserDto)">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="绑定角色" :visible.sync="dialogbdjs" width="22%">
            <el-form ref="userRoleDto" :model="userRoleDto" label-width="80px" label-position="right" size="small">
                <el-form-item label="角色:">
                     <el-select  v-model="userRoleDto.roleId" placeholder="请选择" clearable>
               <el-option v-for="item in options2" :key="item.roleId" :label="item.roleName" :value="item.roleId">
               </el-option>
               </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogbdjs = false">取 消</el-button>
                <el-button type="primary"  @click="oks2()">确 定</el-button>
            </div>
        </el-dialog>
  </div>
  </template>
  <script>
  import { ls } from "shelljs";
import ipConfig from "../../utils/ipconfig";
import Compressor from 'compressorjs';
     export default {
     name:'userwxpart',
     data(){
      return{
         userDto:{
            pageNum:1,
            pageSize:10,
            phone:null,
            userType:null,
         },
         tableData: [],
         totals:10,
         increase:false,
         dialogbdjs:false,
         registerUserDto:{
            email:'',
            imgUrl:'',
            phone:'',
            pwd:'',
            userName:'',
            userType:'1'
         },
         yhlxoptions: [{
            value: '1',
            label: '管理员'
         }, {
            value: '2',
            label: '区域经理'
         }],
         zcrules: {
            userName: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            pwd: [
               { required: true, message: '请输入密码', trigger: 'blur' },
               {
               validator: (rule, value, callback) => {
                  const regex = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,}$/;
                  if (value === '') {
                  callback(new Error('请输入密码'));
                  } else if (!regex.test(value)) {
                  callback(new Error('密码必须包含字母和数字，且长度至少为八位'));
                  } else {
                  callback();
                  }
               },
               trigger: 'blur'
               }
            ],
            phone: [
               { required: true, message: '手机号不能为空', trigger: 'blur' },
               {
                  validator: (rule, value, callback) => {
                  const phoneRegex = /^1[3-9]\d{9}$/;
                  if (!value) {
                        callback(new Error('请输入手机号'));
                  } else if (!phoneRegex.test(value)) {
                        callback(new Error('请输入有效的手机号'));
                  } else {
                        callback();
                  }
                  },
                  trigger: 'blur'
               }
            ]
         },
         fileList: [],
         dialogImageUrl: '',
         dialogVisible: false,
         dialogFormVisible: false,
         uploadUrl:'',
         resetPwdDto:{
            userId:null
         },
         userRoleDto:{
            roleId:null,
            userId:null,
         },
         options2: [],

      }
     },
     created(){
      this.getlist(this.userDto)
     },
     mounted(){
     },
     methods:{
      getlist(userDto) {
         this.$api.hqyhlist(userDto)
         .then((res) => {
            if (res.data.code == 200) {
               this.tableData = res.data.data.records
               this.totals = res.data.data.total
            } else {
               this.$message.error(res.data.message)
            }
         })
      },
      newoks() {
         this.increase = true
      },
      handleRequest(request) {
         const formData = new FormData();
         formData.append('file', request.file); // 这里的 'file' 是后端接收文件的字段名
         this.$api.uploadPackage({
            file:request.file
         }).then((res) => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                  request.onSuccess(res.data.data); // 当请求成功时，调用 onSuccess
                } else {
                    this.$message.error(res.data.message)
                }
            })
      },
      // 上传前的处理函数
      // beforeUpload(file) {
      //   // 限制文件类型
      //   const isImage = file.type.startsWith('image/');
      //    const isVideo = file.type === 'video/mp4';
      //    if (!isImage && !isVideo) {
      //    this.$message.error('只能上传图片或 MP4 格式的视频文件');
      //    return false;
      //    }
      //    // 限制文件大小
      //    const maxSize = 30 * 1024 * 1024; // 100MB
      //    if (file.size > maxSize) {
      //    this.$message.error('文件大小不能超过 30MB');
      //    return false;
      //    }
      //    return true;
      // },
      beforeUpload(file) {
          return new Promise((resolve, reject) => {
            if (file.type.startsWith('video/mp4')) {
              resolve();
            } else if (file.type.startsWith('image')) {
              new Compressor(file, {
                quality: 0.85,        // 压缩质量，范围 0 - 1
                maxWidth: 800,       // 图片最大宽度
                maxHeight: 800,      // 图片最大高度
                mimeType: 'image/jpeg', // 强制压缩为 JPEG 格式
                success: (compressedFile) => {
                  file.compressed = compressedFile;
                  resolve();
                },
                error: (err) => {
                  console.error('图片压缩失败', err);
                  reject('图片压缩失败');
                },
              });
            } else {
              reject('只支持上传图片和 MP4 格式视频');
            }
          });
        },
      handleExceed(files, fileList) {
         this.$message.warning('已超出只能上传一张图片的限制，请先移除现有图片再上传新图片。');
      },
      // 图片上传成功的回调函数
      handleSuccess(response, file, fileList) {
         this.registerUserDto.imgUrl = file.response.oriFileUrl
         // 这里可以处理成功后的逻辑，例如展示上传后的图片
         this.fileList.push({
            name: file.name,
            url: response.oriFileUrl // 更新图片的链接
        });
      },
      // 图片上传失败的回调函数
      handleError(error, file, fileList) {
         this.$message.error('图片上传失败');
      },
      // 预览图片
      handlePreview(file) {
      },
      // 删除图片
      handleRemove(file, fileList) {
         this.fileList=[]
         this.registerUserDto.imgUrl=''
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.registerUserDto={
            email:'',
            imgUrl:'',
            phone:'',
            pwd:'',
            userName:'',
            userType:'1'
         }
         this.fileList=[]
         this.registerUserDto.imgUrl=''
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      handleClick(row) {
            this.dialogFormVisible = true;
            this.$api.userDetail({
                userId:row.userId
            }).then((res)=>{
               if (res.data.code == 200) {
                     this.fileList=[]
                     this.registerUserDto = res.data.data
                     if (this.registerUserDto.imgUrl) {
                        if (this.registerUserDto.imgUrl.startsWith('https://')) {
                           this.registerUserDto.imgUrl= this.registerUserDto.imgUrl
                        } else {
                           this.registerUserDto.imgUrl = ipConfig.baseUrl+this.registerUserDto.imgUrl
                        }
                        this.fileList.push({
                              url: this.registerUserDto.imgUrl
                        });
                     }
                  } else {
                     this.$message.error(res.data.message)
                  }
              
            })
        },
      submitForm(formName,data) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.yhzcregister(data).then((res) => {
                    if (res.data.code == 200) {
                        this.increase = false
                        this.registerUserDto={
                                 email:'',
                                 imgUrl:'',
                                 phone:'',
                                 pwd:'',
                                 userName:'',
                              }
                        this.getlist(this.userDto)
                        this.$message.success(res.data.message)
                    } else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        return
                    }
                })
            } else {
                return false;
            }
            });
        },
        xiugoks(registerUserDto,data) {
            this.$refs[registerUserDto].validate((valid) => {
            if (valid) {
                this.$api.updateUser(data).then((res)=>{
                if(res.data.code==200){
                    this.getlist(this.userDto)
                    this.dialogFormVisible = false;
                    this.registerUserDto={
                        email:'',
                        imgUrl:'',
                        phone:'',
                        pwd:'',
                        userName:'',
                     }
                     this.registerUserDto.imgUrl=''
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
                })
            } else {
                return false;
            }
            });
        },
      dels(e) {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deleteUser({
            userId:e.userId
            }).then((res) => {
              if (res.data.code == 200) {
                  this.getlist(this.userDto)
                  this.$message.success(res.data.message)
               } else {
                  this.$message.error(res.data.message)
               }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      czsydemm(row){
          this.$confirm('是否确定重置密码?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$api.czmmresetPwd({
                userId:row.userId
              })
              .then((res) => {
                  if (res.data.code == 200) {
                     this.getlist(this.userDto)
                     this.$message.success(res.data.message)
                  } else {
                     this.$message.error(res.data.message)
                  }
              })
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消'
              });          
          });
      },
      intos(e){
         this.userRoleDto.userId = e.userId
         this.dialogbdjs = true
         this.$api.hqjsbfylist().then((res)=>{
            this.options2 = res.data.data
            if(res.data.code==200){
               this.options2 = res.data.data
            }else{
               this.$message.error(res.data.message)
            }
         })
      },
      oks2(){
         this.$api.bindRole(this.userRoleDto).then((res)=>{
            if(res.data.code==200){
               this.$message.success(res.data.message)
               this.dialogbdjs=false
               this.getlist(this.userDto)
            }else{
               this.$message.error(res.data.message)
            }
         })
      },
      sjhsearchFor(){
         this.getlist(this.userDto)
      },
      handleCurrentChange(val) {
          this.userDto.pageNum = val
          this.getlist(this.userDto)
        },
        handleSizeChange(val) {
          this.userDto.pageSize = val
          this.getlist(this.userDto)
        },
     }
     }
  </script>
<style scoped>
#userwxpart {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* background: yellow; */
  margin-bottom: 20px;
  margin-left: -30px;
}
.elrow{
  box-sizing: border-box;
  width: 20%;
  margin-top: -6px;
  margin: 0 40px 0 20px;
}
.elrowleft{
  width: 80%;
  float: left;
  box-sizing: border-box;
}
.elrowleft input{
  border: 2px solid #1b93ed !important;
  border-radius: 0 !important;
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #929da5;
  box-sizing: border-box;
  color: #1f3d35;
  font-size: 14px;
  height: 36px;
  line-height: 1;
  outline: none;
  padding: 3px 10px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.elrowcontent{
  width: 16.66667%;
  float: left;
  box-sizing: border-box;
}
.search-btn {
  height: 36px;
  width: 100px;
  background: #1b93ed;
  border: 2px solid #1b93ed;
  margin: 0;
  padding: 0;
  color: #fff;
  cursor: pointer;
}
.right-item {
  margin-left: auto; /* Pushes the item to the right */
}
.tos /deep/ .el-form-item {
    margin-bottom: 0 !important;
}
.btnbox {
      /* background: pink; */
      display: flex;
      width: 40%;
      align-items: center;
      justify-content: space-around;
      margin: auto;
      margin-top: 30px;
  }
  .zcyhtk /deep/ .el-form-item__label {
    width: 90px !important;
  }
  .zcyhtk /deep/ .el-form-item__content {
    margin-left: 90px !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/xtglwxpart/userwxpart.vue